import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccount = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15.5 15.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		"data-name": "Icon - Account",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M6.533 9.576s-.913-.3-.913-1.826c-.5 0-.5-1.217 0-1.217 0-.2-.913-2.435.609-2.13.3-1.217 3.652-1.217 3.957 0a4.822 4.822 0 0 1-.3 2.13c.5 0 .5 1.217 0 1.217 0 1.522-.913 1.826-.913 1.826V11.1a21.32 21.32 0 0 1 3.765 1.567 7 7 0 1 0-9.959.007A21.638 21.638 0 0 1 6.533 11.1Z",
			"data-name": "Path 4988"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.775 12.672a7 7 0 0 0 9.958-.007",
			"data-name": "Path 4989"
		})]
	})
});
export { SvgAccount as ReactComponent };
